import { FlaskConical } from "lucide-react";

const TestingHubTileDesign = {
  id: "testing-hub",
  icon: FlaskConical,
  label: "Testing Hub",
  background: "linear-gradient(135deg, #0f766e, #2563eb)",
  color: "#ffffff",
};

export default TestingHubTileDesign;
